import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef, Component, EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewContainerRef
} from '@angular/core';
import { OnDestroy$ } from '@pdtec/ngx-observable-lifecycle';
import { HTTPSearchResultTour, ITouristsParams } from 'src/app/models';
import {environment} from "../../../../environments/environment";
import { PriceFormatPipe } from '../../pipes/price-format/price-format.pipe';
import {TemplateReplacePipe} from "../../pipes/trmplate-replace/template-replace.pipe";
import {SafeHtml} from "@angular/platform-browser";
import {TourCreditComponent} from "../tour-credit/tour-credit.component";
import {TourPricesValueComponent} from "../tour-prices/value/tour-prices-value.component";
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../../config/hotel-tours-list-page.config";

@Component({
  selector: 'app-tour-prices',
  templateUrl: environment.mobile ? './tour-prices.component.mobile.html' : './tour-prices.component.html',
  styleUrls: environment.mobile ? ['./tour-prices.component.mobile.scss'] : ['./tour-prices.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TourCreditComponent, TourPricesValueComponent, PriceFormatPipe]
})
export class TourPricesComponent extends OnDestroy$ implements OnInit, OnDestroy {
  @Input() tour: HTTPSearchResultTour;

  isShowPrice = true;

  // Идет поиск туров
  @Input() isSearchRunning: boolean;

  variantCount = 0;

  @Output() onRecalcTour = new EventEmitter<ITouristsParams>();
  @Output() onShowTours = new EventEmitter<ITouristsParams>();
  recalcRef: ViewContainerRef;

  @Input() touristsLabel;

  // Показывать цена за тур - при пересчете мы всегда выводим за тур
  public isShowByTour = false;
  public isShowTours = false;
  public isShowCreditButton = false;
  public showToursLabel = 'Показать туры';

  messages: any = {};

  constructor(
    @Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig,
    private ch: ChangeDetectorRef,
  ) {
    super();
    this.isShowByTour = !hotelToursPageConfig.isShowPriceByOne;
    this.messages = this.hotelToursPageConfig.translates.tourPrices;
    this.showToursLabel = this.messages.showTours;
  }

  get touristLabel(): SafeHtml {
    const pipe = new TemplateReplacePipe();
    const children = this.tour?.childAges ? this.tour?.childAges.length : 0;

    if (children > 0) {
      return pipe.transform(this.messages.touristsCountWithChildren, {
        'adults': this.tour.adults,
        'children': children,
      });
    }

    return pipe.transform(this.messages.touristsCount, {
      'adults': this.tour.adults,
    });
  }

  ngOnInit() {
  }

  ngOnDestroy() { }

  public get isToursShown(): boolean {
    return this.isShowTours;
  }

  get tourPrice() {
    // todo
    return this.isShowByTour ? this.tour.price.value : this.tour.price.value;
  }

  get priceWithoutDiscount() {
    if (this.hotelToursPageConfig.manualDiscount) {
      return Math.ceil((this.tourPrice * (100 + this.hotelToursPageConfig.manualDiscount)) / 100);
    }

    return 0;
  }

  showRecalcPopup() {
    if (this.isSearchRunning) {
      return;
    }
  }

  onViewTours() {

  }

  private resetShowToursLabel() {
    let tourists = { adult: 1, child: 0 } as any;
    if (!this.hotelToursPageConfig.isShowPriceByOne) {
      tourists = {
        adult: this.tour.adults,
        child: this.tour.childAges.length || 0,
      };
    }
    this.isShowTours = false;
    this.isShowByTour = !this.hotelToursPageConfig.isShowPriceByOne;

    this.ch.markForCheck();
  }

  private toggleShowToursLabel() {
    this.showToursLabel = this.isShowTours ? this.messages.hideTour : this.messages.showTour;
    if (this.variantCount > 1) {
      this.showToursLabel = this.isShowTours ? this.messages.showTours : this.messages.hideTours;
    }

    this.ch.markForCheck();
  }

  public get getCashback() {
    const price = this.tour.price.value;
    return TourPricesComponent.calculateCashbackForTour(price);
  }

  public get getCurrency() {
    return this.hotelToursPageConfig.currencySign;
  }

  private static calculateCashbackForTour(tourPrice: number): number {
    const maxCashback = 120000;
    const minCashback = 15000;

    // Если тур стоит 1кк и более, то за каждые 500,000 тенге клиент получает 6,850 бонусов, но не менее 15,000 тенге
    if (tourPrice > 1000000) {
      const cashback = Math.floor(tourPrice / 500000) * 6850;
      return Math.min(Math.max(cashback, minCashback), maxCashback);
    }

    // Если тур стоит <= 1,000,000 тенге, то 2% от стоимости тура, но не более 15,000 тенге
    const cashback = Math.ceil(tourPrice * 2 / 100);
    return Math.min(cashback, minCashback);
  }
}
